var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row", attrs: { id: "settings-container" } },
    [
      _c("account-navigation", {
        attrs: { "current-page": _vm.currentPage },
        on: { "page-change": _vm.handlePageChange },
      }),
      _vm._v(" "),
      _c(_vm.currentPage + "-container", {
        tag: "component",
        attrs: {
          saving: _vm.saving,
          "allow-save": _vm.allowSave,
          "nylas-account": _vm.nylasAccount,
        },
        on: {
          "clear-nylas-account": function ($event) {
            return _vm.$emit("clear-nylas-account")
          },
          "allow-save": _vm.handleAllowSave,
          "finish-saving": _vm.handleFinishSaving,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }